<script lang="ts" setup>
import AppSvgIcon from '../appSvgIcon/AppSvgIcon.vue';

import type { AppTabProps } from './AppTabs.model';

const props = defineProps<AppTabProps>();
</script>

<template>
  <div class="app-tab" :class="{ open: props.isOpen }">
    <div class="app-tab-title">
      <div v-if="props.icon" class="app-tab-icon">
        <AppSvgIcon :name="props.icon" size="18" />
      </div>
      <div class="app-tab-title-text">
        {{ props.title }}
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '../../styles/_fonts.scss';
.app-tab {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  padding: var(--spacing-12) var(--spacing-16);
  cursor: pointer;
  transition: color var(--transition-short);

  &.open {
    .app-tab-title {
      color: var(--color-secondary-40);
    }
  }

  .app-tab-title {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: var(--spacing-8);
    color: var(--color-secondary-60);

    .app-tab-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: var(--border-radius-12);
    }

    .app-tab-title-text {
      @include font-label-l-bold;
    }
  }
}
</style>
